import { Session } from 'next-auth';

import { UNIT_VOLUME_CBM_FULL, UNIT_WEIGHT_KG } from '@/lib/constants';
import { QuoteFormInputsInterface } from '@/types';

import { QUOTE_FORM_FIELDS } from './constants';

export const getQuoteFormDefaultValues = (session: Session | null): QuoteFormInputsInterface => {
  return {
    [QUOTE_FORM_FIELDS.CARGO_TYPE]: '',
    [QUOTE_FORM_FIELDS.QUANTITY]: 0,
    [QUOTE_FORM_FIELDS.CONTAINER_SIZE]: '',
    [QUOTE_FORM_FIELDS.CARGO_DESCRIPTION]: '',
    [QUOTE_FORM_FIELDS.TOTAL_VOLUME]: 0,
    [QUOTE_FORM_FIELDS.UNIT_VOLUME]: UNIT_VOLUME_CBM_FULL,
    [QUOTE_FORM_FIELDS.TOTAL_WEIGHT]: 0,
    [QUOTE_FORM_FIELDS.UNIT_WEIGHT]: UNIT_WEIGHT_KG,
    [QUOTE_FORM_FIELDS.NUMBER_OF_ITEMS]: 0,
    [QUOTE_FORM_FIELDS.ITEM_CATEGORY]: '',
    [QUOTE_FORM_FIELDS.SPECIAL_HANDLING]: '',
    [QUOTE_FORM_FIELDS.ORIGIN]: '',
    [QUOTE_FORM_FIELDS.DESTINATION]: '',
    [QUOTE_FORM_FIELDS.READY_FOR_PICKUP]: '',
    [QUOTE_FORM_FIELDS.SHIPMENT_DETAILS]: '',
    [QUOTE_FORM_FIELDS.NAME]: session?.user.name || '',
    [QUOTE_FORM_FIELDS.BUSINESS_NAME]: session?.user.businessName || '',
    [QUOTE_FORM_FIELDS.EMAIL]: session?.user.email || '',
    [QUOTE_FORM_FIELDS.PHONE]: '',
    [QUOTE_FORM_FIELDS.COUNTRY]: session?.user.country || '',
    [QUOTE_FORM_FIELDS.SENDS_CARGO_REGULARLY]: '',
  };
};
